import { HomeIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import moment from "moment";
import Pagination from "../../../components/Pagination";
import { isEmpty } from "lodash";
import useLoading from "../../../hooks/useLoading";
import { Link, useNavigate } from "react-router-dom";
import { getUserList, getUserListCount, getUserOrgTree } from "../../../services/ api_services";
import SelectMenu from "../../../components/SelectMenu";
import { ROLES } from "../../../core/constants";
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const pages = [{ name: "회원 관리", href: "/user", current: false }];

const searchType = [
    { name: "성명", value: "name" },
    { name: "휴대전화", value: "phone" },
    { name: "이메일", value: "email" },
    { name: "추천인", value: "referrer" },
];

export default function User() {

    const adminOrgId = sessionStorage.getItem("adminOrgId");
    const adminLevelCd = sessionStorage.getItem("adminLevelCd");

    // const dbConfig = localStorage.getItem('X-DB-KEY');
    // const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === 'urinalysis';

    const navigate = useNavigate();
    const { setLoading } = useLoading();

    const initialCond = {
        search_word: "",
        search_type: "",
    };

    const pageSizes = [20, 50, 100];
    const [selected, setSelected] = useState(searchType[0]);
    const [list, setList] = useState([]);
    const [cond, setCond] = useState(initialCond);
    const [sortOrders, setSortOrders] = useState({user_reg: 'DESC'});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(pageSizes[0]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [orgTreeValues, setOrgTreeValues] = useState([]);
    const [orgId, setOrgId] = useState({ name: "선택", id: null });

    useEffect(() => {
        onSearch();
        console.log(sortOrders);
        // if (isUrinalysis()) {
            selectUserOrgTree();
        // }
    }, [currentPage, pageSize, sortOrders]);

    const onSearch = () => {
        const data = {
            page_number: currentPage,
            page_size: pageSize,
            search_word: cond.search_word,
            search_type: selected.value,
            search_org: orgId.id,
            view_referrer: "False",
            admin_level_cd: adminLevelCd,
            admin_org_id: adminOrgId,
            sortOrders: sortOrders,
        };
        console.log("🚀 ~ fetchUserList ~ data:", data);

        fetchUserList(data);
        fetchTotalCount(data);
    };

    /**
     * 전체 카운트 API
     * @returns
     */
    const fetchTotalCount = async (data) => {
        console.log("🚀 ~ fetchTotalCount ~ data:", data);
        try {
            const response = await getUserListCount(data);
            console.log("🚀 ~ fetchTotalCount ~ response:", response);
            if (response && response.status === 200) {
                console.log("response.data ==>", response.data);
                if (response.data) {
                    setTotalCount(Number(response.data));
                } else {
                    setTotalCount(0);
                }
            } else {
                setTotalCount(0);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };


    //상세정보 채우기 위한 회원구분(조직) Api 로 값 불러오기
    const selectUserOrgTree = async () => {
        try {
            const orgData = {
                org_id: adminOrgId,
                use_yn: "0001"
            }

            const response = await getUserOrgTree(orgData);
            const data = response.data;
            console.log("🚀 ~ getUserOrgTree ~ response:", response);

            const formattedOptions = [
                { name: "선택", id: null }, // null 옵션 추가
                ...data.map((item) => ({
                    name: item.full_path,
                    id: item.org_id.toString(),
                    total_coupon: item.total_coupon,
                    issued_coupon: item.issued_coupon,
                    referrer_count: item.referrer_count,
                })),
            ];

            setOrgTreeValues(formattedOptions);
            

        } catch (error) {
            console.error("옵션 데이터를 불러오지 못했습니다:", error);
        }
    };


    /**
     * 이름, 핸드폰 번호 조회 함수
     * @returns
     */
    async function fetchUserList(data) {
        setLoading(true);
        console.log("data ==>", data);
        try {
            const response = await getUserList(data);
            console.log("🚀 ~ fetchUserList ~ response:", response);
            // const response = await nonAuthInstance.post("/user/select/all/list", condTmp);
            setLoading(false);

            if (response.status === 200 && !isEmpty(response.data)) {
                console.log("response.data ==>", response.data);
                setList(response.data);
            } else {
                setList([]);
                // console.log("response===>", response);
            }
        } catch (e) {
            setLoading(false);
            console.log("e===>", e);
        }
    }

    /**
     * 엔터키 이벤트
     * @returns
     */
    const handleOnKeyPress = (e) => {
        if (e.keyCode === 13) {
            onSearch(); // Enter 입력이 되면 클릭 이벤트 실행
        }
    };

    /**
     * 날짜 포맷
     * @returns
     */
    function formatDate(date) {
        const formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
        return formattedDate;
    }

    /**
     * 페이지 사이즈
     * @returns
     */
    const handleOnSelectPageSize = (pageSize) => {
        // console.log("pageSize ==>", pageSize);
        setPageSize(Number(pageSize));
    };

    const handleOnClickColumn = (col)  => {
        console.log('handleOnClickColumn====>',col);
        
        setSortOrders((prev) => {
            const current = prev[col];  // 현재 정렬 상태 확인

            if (current === undefined) {    // 초기값 없으면 바로 ASC로 추가
                return {
                ...prev,
                [col]: 'ASC',
                };
            }

            let nextOrder;
            if (current === 'ASC') nextOrder = 'DESC';
            else if (current === 'DESC') nextOrder = null;
            else nextOrder = 'ASC';

            const newSortOrders = { ...prev, [col]: nextOrder };
            if (nextOrder === null) {   // 정렬 없으면 삭제
                delete newSortOrders[col];
            }

            return newSortOrders;
        });
        setCurrentPage(1);

    };

    const renderSortIcon = (col) => {
        const order = sortOrders[col];
        if (order === 'ASC') return <FaSortUp />;
        if (order === 'DESC') return <FaSortDown />;
        return <FaSort />;
    };

    const handleOnClickListRow = (item) => {
        console.log('adminInfo.admin_level_cd==>', adminLevelCd);
        if (adminLevelCd === ROLES.Admin || adminLevelCd === ROLES.Volunteer) {
            navigate("/ad/userInfo/" + item.user_seq, {state: {products: orgTreeValues}});
        }
        else {
            navigate("/user/userInfo/" + item.user_seq, {state: {products: orgTreeValues}});
        }
    };

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <Link
                                    to={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </Link>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <div className=" bg-gray-900 max-w-full mt-2 h-max ">
                <div className="mx-auto max-w-full">
                    <div className="bg-gray-900 py-10">
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="mt-5 flex justify-between">
                                <div className="flex w-7/12 space-x-3 sm:space-x-2">
                                    <div className="min-w-32">
                                        <SelectMenu options={searchType} onSelect={setSelected} selectedId={selected.value} />
                                    </div>
                                    <input
                                        type="search"
                                        className="block w-5/12 rounded border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                        maxLength={30}
                                        onChange={(e) => {
                                            setCond((prevState) => {
                                                return { ...prevState, search_word: e.target.value.trim() };
                                            });
                                        }}
                                        onKeyDown={handleOnKeyPress}
                                    />
                                    <div className="block w-6/12">
                                        <SelectMenu options={orgTreeValues} onSelect={setOrgId} selectedId={orgId.value}/>
                                    </div>
                                    <button
                                        type="button"
                                        className="whitespace-nowrap rounded bg-white py-2 px-5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 "
                                        onClick={() => {
                                            onSearch();
                                        }}
                                    >
                                        검색
                                    </button>
                                </div>
                                <div className="flex space-x-10">
                                    <div className="flex items-center justify-between align-middle">
                                        <label className="w-20 text-start text-sm font-medium text-white">조회 개수 </label>
                                        <select
                                            id="location"
                                            name="location"
                                            className="block w-24 rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            defaultValue={pageSizes && pageSizes[0]}
                                            onChange={(e) => handleOnSelectPageSize(e.target.value)}
                                        >
                                            {pageSizes.map((item) => {
                                                return <option>{item}</option>;
                                            })}
                                        </select>
                                    </div>
                                    {/* <button
                                        type="button"
                                        className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-500 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400"
                                        onClick={() => navigate("/ad/addUser")}
                                    >
                                        <UserPlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                        회원 등록
                                    </button> */}
                                </div>
                            </div>
                            <div className="mt-8 flow-root">
                                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                        <table className="min-w-full divide-y divide-gray-700">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="py-3.5 px-1 min-w-4 text-left text-sm font-semibold text-white sm:pl-0">
                                                        NO
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_nm')}>
                                                        <div className="flex items-center gap-1">
                                                            성명 {renderSortIcon('user_nm')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_hp_no')}>
                                                        <div className="flex items-center gap-1">
                                                            휴대전화번호 {renderSortIcon('user_hp_no')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_bir')}>
                                                        <div className="flex items-center gap-1">
                                                            생년월일 {renderSortIcon('user_bir')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_coupon_end')}>
                                                        <div className="flex items-center gap-1">
                                                            사용 기간 {renderSortIcon('user_coupon_end')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_reg')}>
                                                        <div className="flex items-center gap-1">
                                                            가입일 {renderSortIcon('user_reg')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('org_full_path')}>
                                                        <div className="flex items-center gap-1">
                                                            회원구분(조직) {renderSortIcon('org_full_path')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('referrer_user_nm')}>
                                                        <div className="flex items-center gap-1">
                                                            추천인 {renderSortIcon('referrer_user_nm')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_type')}>
                                                        <div className="flex items-center gap-1">
                                                            상태 {renderSortIcon('user_type')}
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="py-3.5 px-3 text-center text-sm font-semibold text-white sm:pl-0 cursor-pointer"
                                                        onClick={() => handleOnClickColumn('user_app_version')}>
                                                        <div className="flex items-center gap-1">
                                                            버전 {renderSortIcon('user_app_version')}
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-800">
                                                {list &&
                                                    list.map((person, index) => { return (
                                                        <tr
                                                            className="hover:bg-slate-800"
                                                            key={person.user_seq}
                                                            onClick={() => handleOnClickListRow(person)}
                                                        >
                                                            <td className="whitespace-nowrap text-left py-2 px-3 text-sm font-medium text-white sm:pl-0">
                                                                {index + 1}
                                                            </td>
                                                            <td className="whitespace-nowrap text-left text-sm text-gray-300">
                                                                {person.user_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3  text-left text-sm text-gray-300">
                                                                {person.user_hp_no}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-left  text-sm text-gray-300">
                                                                {person.user_bir}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3  text-left text-sm text-gray-300">
                                                                {person.user_coupon_start} ~ {person.user_coupon_end}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3  text-left text-sm text-gray-300">
                                                                {formatDate(person.user_reg)}
                                                                {/* {person.user_reg} */}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-left  text-sm text-gray-300">
                                                                {person.org_full_path}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-left  text-sm text-gray-300">
                                                                {person.referrer_user_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-center text-sm text-gray-300">
                                                                {person.spec_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-center text-sm text-gray-300">
                                                                {person.user_app_version}
                                                            </td>
                                                        </tr>
                                                    )})
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                totalCount={totalCount}
                itemsPerPage={pageSize}
            />
        </div>
    );
}
